<template>
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" :model="filteForm" class="toolbar">
        <el-form-item label="日期">
          <el-date-picker v-model="filteForm.scheduledDate" type="date" value-format="yyyy-MM-dd" @change="loadData" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="loadData">刷新</el-button>
        </el-form-item>
      </el-form>
      <el-alert title="以下为超过计划时间30分钟仍未完成的任务，请填写原因后关闭" type="error" show-icon :closable="false" style="margin-bottom:12px" />
      <el-table v-loading="loading" :data="dataList" :header-cell-style="headerStyle">
        <el-table-column label="时间" width="140" align="center">
          <template slot-scope="s">{{ s.row.scheduledDate }} {{ s.row.scheduledTime }}</template>
        </el-table-column>
        <el-table-column label="老人" prop="oldmanName" width="90" align="center" />
        <el-table-column label="项目" prop="projectName" align="center" />
        <el-table-column label="护工" prop="assignedNurseName" width="90" align="center" />
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="s">
            <el-button type="danger" size="mini" plain @click="closeTask(s.row)">关闭</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="关闭超时任务" :visible.sync="dialogVisible" width="440px">
        <el-form label-width="90px">
          <el-form-item label="超时原因" required>
            <el-input v-model.trim="closeForm.timeoutReason" type="textarea" :rows="3" />
          </el-form-item>
        </el-form>
        <div slot="footer" align="center">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitClose">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  name: "NursingTaskTimeout",
  data() {
    const d = new Date();
    const today = d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
    return {
      filteForm: { scheduledDate: today, statusList: [3], pageNum: 1, pageSize: 50 },
      dataList: [],
      loading: false,
      dialogVisible: false,
      closeForm: {}
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$postJson("omc/nursingTask/monitorQuery", this.filteForm).then(res => {
        this.loading = false;
        if (res.code == 200 && res.result && res.result.tasks) {
          this.dataList = res.result.tasks.list || [];
        }
      }).catch(() => { this.loading = false; });
    },
    closeTask(row) {
      this.closeForm = { taskId: row.id, timeoutReason: "" };
      this.dialogVisible = true;
    },
    submitClose() {
      if (!this.closeForm.timeoutReason) return this.$message.warning("请填写超时原因");
      this.$postJson("omc/nursingTask/closeTimeout", this.closeForm).then(res => {
        if (res.code == 200) {
          this.$message.success("已关闭");
          this.dialogVisible = false;
          this.loadData();
        } else this.$message.error(res.message);
      });
    },
    headerStyle({ rowIndex }) { if (rowIndex === 0) return "background:#d4f5fa;font-weight:600"; }
  },
  mounted() { this.loadData(); }
};
</script>
